
import { ServiceApplication_Key } from "../../../../config/helpers";
import { IDemandeInscriptionData, IDemandeInscriptionCreateData, IDemandeInscriptionCreateReturn, IDemandeInscriptionEmailExistData, IDemandeInscriptionEmailExistReturn, IDemandeInscriptionVerifyCodeData, IDemandeInscriptionVerifyCodeReturn } from "../../../../models/interfaces/IDemandeInscription";

import { apiSlice } from "../../api";



export interface DemandeInscriptionApiQueryBody {
    Application_Key: string;
    Values: IDemandeInscriptionData;
}

export interface DemandeInscriptionCreateApiQueryBody {
    Application_Key: string;
    Values: IDemandeInscriptionCreateData;
}

export interface DemandeInscriptionEmailExistApiQueryBody {
    Application_Key: string;
    Values: IDemandeInscriptionEmailExistData;
}

export interface DemandeInscriptionVerifyCodeApiQueryBody {
    Application_Key: string;
    Values: IDemandeInscriptionVerifyCodeData;
}

export const DemandeInscriptionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchDemandeInscriptionCreate: builder.mutation<IDemandeInscriptionCreateReturn, IDemandeInscriptionCreateData>({
      query: (obj) => {
        const body: DemandeInscriptionCreateApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: obj,
        };

        return {
          url: "/DemandeInscription/Demande_Inscription_Create",
          method: "POST",
          body: body,
        };
      },
    }),
    demandeInscriptionEnvoiMail: builder.query<IDemandeInscriptionEmailExistReturn, string>({
      query: (email: string) => {
        const body: DemandeInscriptionEmailExistApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: { Login: email },
        };

        return {
          url: "/DemandeInscription/Demande_Inscription_EnvoiMail",
          method: "POST",
          body: body,
        };
      },
    }),
    demandeInscriptionVerifyCode: builder.mutation<IDemandeInscriptionVerifyCodeReturn, IDemandeInscriptionVerifyCodeData>({
      query: (data: IDemandeInscriptionVerifyCodeData) => {
        const body: DemandeInscriptionVerifyCodeApiQueryBody = {
          Application_Key: ServiceApplication_Key,
          Values: data,
        };

        return {
          url: "/DemandeInscription/Demande_Inscription_VerifyCode",
          method: "POST",
          body: body,
        };
      },
    }),
    
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFetchDemandeInscriptionCreateMutation,
  useLazyDemandeInscriptionEnvoiMailQuery,
  useDemandeInscriptionVerifyCodeMutation,

} = DemandeInscriptionApi;
